import React from "react";
import { Helmet } from "react-helmet";
import { Article, Person } from "schema-dts";
import { helmetJsonLdProp } from "react-schemaorg";
import { ContentPostFragment } from "../../types/graphql";
import { linkTo } from "../../utils/contentUtils";

interface IArticleMetaData {
  contentPost: ContentPostFragment;
}

interface IAuthor {
  same_as_links: [
    {
      same_as_link: any;
    }
  ];
  name: string;
  honorific_prefix: string;
  honorific_suffix: string;
  author_page: {
    document: any;
  };
}

const ArticleMetaData = (props: IArticleMetaData) => {
  const { contentPost } = props;

  // fields?.publication_date_timestamp missing during previews
  const publicationDate =
    contentPost.fields?.publication_date_timestamp ||
    contentPost.first_publication_date;

  const authorDoc = contentPost.data?.author?.document;
  const author = (authorDoc && "data" in authorDoc && authorDoc.data) || null;

  const editorDoc = contentPost.data?.editor?.document;
  const editor = (editorDoc && "data" in editorDoc && editorDoc.data) || null;

  const getAuthorObj = (author: IAuthor) => {
    return {
      "@type": "Person",
      name: author?.name || "",
      ...(author?.honorific_prefix && {
        honorificPrefix: author?.honorific_prefix,
      }),
      ...(author?.honorific_suffix && {
        honorificSuffix: author?.honorific_suffix,
      }),
      ...(author?.author_page?.document && {
        url: "https://www.xometry.com" + linkTo(author?.author_page?.document), // Link to author's page
      }),
    };
  };

  let authors = [getAuthorObj(author as IAuthor)];

  if (editor !== null) {
    authors.push(getAuthorObj(editor as IAuthor));
  }

  const renderMetaData = () => {
    return (
      <Helmet
        script={[
          helmetJsonLdProp<Article>({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: contentPost.data?.title || "",
            image: [contentPost.data?.image?.url || ""],
            datePublished: new Date(publicationDate).toISOString(),
            dateModified: new Date(
              contentPost.last_publication_date
            ).toISOString(),
            author: authors as unknown as Person,
            publisher: {
              "@type": "Organization",
              name: "Xometry",
              logo: {
                "@type": "ImageObject",
                url: "https://www.xometry.com/xometry-logo.png",
              },
            },
          }),
        ]}
      />
    );
  };

  return <>{renderMetaData()}</>;
};

export default ArticleMetaData;
